import { render } from "./helpPage.vue?vue&type=template&id=3d36a2a0"
import script from "./helpPage.vue?vue&type=script&lang=js"
export * from "./helpPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__